import { Plural, Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { ActivityMediumLink } from '@/components/activities/ActivityMediumLink';
import {
  BaseActivity,
  BaseActivityArticlesNames,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconValidation from '@/icons/Validation.svg';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

export const JobAcceptedActivity = ({
  activities,
}: {
  activities: ActivityOfType<'job_accepted'>[];
}) => {
  const { iam } = useRequestContext();
  const firstActivity = activities[0];
  const workshopName = firstActivity.workshop.name;
  const creatorName = firstActivity.data.onBehalfOfWorkshop
    ? firstActivity.creator.name
    : `${firstActivity.creator.name} (${workshopName})`;

  const userWorkshopIds = iam.scopesOnRequest
    .filter(({ scope }) => scope === 'workshop')
    .map(({ entityId }) => entityId);
  const hideQuote =
    iam.hasOnlyWorkshopScopeOnRequest && !userWorkshopIds.includes(firstActivity.workshopId);

  return (
    <BaseActivity
      createdAt={firstActivity.createdAt}
      type="primary"
      icon={<IconValidation />}
      message={
        <BaseActivityText>
          {firstActivity.data.onBehalfOfWorkshop ? (
            <Trans id="activities.job_accepted.message.on-behalf">
              <strong>{creatorName}</strong> accepted the job on behalf of {workshopName}{' '}
              <Plural value={activities.length} other="with items:" one="" />
              {activities.length > 1 && (
                <BaseActivityArticlesNames activities={activities} displayArticleName />
              )}
            </Trans>
          ) : (
            <Trans id="activities.job_accepted.message">
              <strong>{creatorName}</strong> accepted the job{' '}
              <Plural value={activities.length} other="with items:" one="" />
              <BaseActivityArticlesNames activities={activities} displayArticleName />
            </Trans>
          )}
        </BaseActivityText>
      }
    >
      {/*
        Activities are ordered by createdAt desc, so [0] is the most recent.
        Each accept regenerates a workshop quote that already includes previously
        accepted articles for this workshop, so only the latest medium is useful.
      */}
      {firstActivity.medium && !hideQuote && <ActivityMediumLink medium={firstActivity.medium} />}
    </BaseActivity>
  );
};
